import {Ref} from 'react'
import {useMoo} from './useMoo'
import {Falsy, truthy} from 'tizra'

/**
 * Merge react refs into a single memoized function ref so you can pass it into
 * an element.
 */
export function useMergedRefs(
  _refs: Array<Ref<any> | Falsy>,
): Ref<any> | undefined {
  const refs = _refs.filter(truthy)
  return useMoo(() => {
    if (refs.length < 2) return refs[0]
    return (value: unknown) => {
      // React 19 refs can return cleanup functions.
      const cleanups = refs
        .map(ref => {
          if (typeof ref === 'function') return ref(value)
          ref.current = value
        })
        .filter(x => typeof x === 'function')
      if (cleanups.length) {
        return () => {
          for (const cleanup of cleanups) {
            cleanup()
          }
        }
      }
    }
  }, refs)
}
